import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { SettingService } from 'src/app/_services/admin/setting.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { AuthenticationService } from 'src/app/auth/authentication.service';

@Component({
    selector: 'app-request-org-delete',
    templateUrl: './request-org-delete.component.html',
    styleUrls: ['./request-org-delete.component.scss'],
    standalone: false
})
export class RequestOrgDeleteComponent implements OnInit {
  translate: any;
deleteReason: any
submitTouched: boolean = true;
  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private router: Router,
    private spinner:NgxSpinnerService,
    private licenseService: SettingService,
    private auth: AuthenticationService,
     private errorUtil: ErrorUtil
  ) { }

  ngOnInit(): void {
    
     this.languageTranslateService.wordSrc$.subscribe(transData => { 
          if(Object.keys(transData).length != 0){
            this.translate = transData
          }
      })
  }
//=================================== Delete Subscription===========================
  setDeleteSubscription(){
      this.spinner.show();
       this.submitTouched = true;
      var req= {
        deleteReason: this.deleteReason
      }
        this.licenseService.cancelSubscription(this.auth.getTenantId(), this.auth.getToken(),req).subscribe((response:any) => {
           console.log( response); // Assuming response is an array of industry details
           if(response.status == 201 || response.status == 200){
            this.modalRef.hide()
           this.spinner.hide();
          this.doLogOut();
          } else {
             this.spinner.hide();
              this.submitTouched = false;
            const title = this.errorUtil.processErrorTitle(response.error,this.translate)
            this.errorUtil.setErrorMessage(response.status, null ,  title, 'error',3000);
           
          }
          
        })   
  }
  //=================================== Log Out ===========================
  doLogOut(){
    this.router.navigate(['login']);
    //this.languageTranslateService.completeSubjects()
    localStorage.clear();
    sessionStorage.clear();
  }
  onOrgNameChange(event: any) {
    console.log(this.deleteReason);
   // this.deleteReason = event;
    if (this.deleteReason && this.deleteReason.trim() === '') {
      this.submitTouched = true;
    }
    else {
      this.submitTouched = false;
    }
  }
}
